/**
 * Whether App should render TopMenu + appShellViewport.
 * Do NOT hide the entire console chrome for arbitrary ?email= on /console/* —
 * that unmounts the navbar until the query string is cleared (refresh often
 * drops stale params, which looked like a scroll bug).
 */
export function shouldShowTopChrome(pathname, search = "") {
  const path = (pathname || "/").split("?")[0].replace(/\/+$/, "") || "/";
  const query = new URLSearchParams(
    String(search || "").startsWith("?") ? String(search).slice(1) : search
  );

  if (/^\/console(?=\/|$)/i.test(path)) {
    return true;
  }

  if (["/login", "/signup", "/verification"].includes(path)) {
    return false;
  }
  if (path.startsWith("/s/") || path.startsWith("/demos/") || path.startsWith("/book/") || path.startsWith("/appointment/")) {
    return false;
  }
  if (/^\/users\/[^/]+\/user_auth$/i.test(path)) {
    return false;
  }
  if (path === "/reset-password" || path.startsWith("/connect/")) {
    return false;
  }
  if (
    path.startsWith("/global_executive/") &&
    query.get("id") &&
    query.get("period")
  ) {
    return false;
  }
  return true;
}
